export const checkIsPossiblePayWithPix = (parcels, selectedContract) => {
  const pad_Cob_Pix = getPadraoCobranca(parcels, selectedContract);
  const isElegivelPix = parcels?.length > 0 && parcels[0].parcela?.elegivelPix;

  return pad_Cob_Pix && isElegivelPix;
};

export const getPadraoCobranca = (parcels, selectedContract) => {
  const padCobPix =
    parcels?.length > 0 &&
    parcels[0].parcela?.idVenda === selectedContract?.idVenda
      ? selectedContract?.contrato?.pad_Cob_Pix
      : selectedContract?.contrato?.pad_Cob_Pix_VendaCarteira;

  return padCobPix;
};
